<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <employee-base-field
          slot="tp_emname"
          :label="customLabel.tp_emname || '人员'"
          v-model="form.main.tp_emname"
          @select="onSelectEmployee"
        />
        <div class="weui-cell" slot="tp_department" v-if="form.main.tp_department">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.tp_department || "部门"}}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.tp_department }}
          </div>
        </div>
        <div class="weui-cell" slot="tp_position" v-if="form.main.tp_position">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.tp_position || "岗位"}}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.tp_position }}
          </div>
        </div>
        <div
          class="weui-cell weui-cell_select weui-cell_select-after"
          slot="tp_type"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.tp_type || "类型"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.tp_type"
              placeholder="请选择"
            >
              <option>转正</option>
              <option>离职</option>
              <option>辞退</option>
              <option>调动</option>
            </select>
          </div>
        </div>
        <template v-if="form.main.tp_type == '离职'">
          <date-field
            :label="customLabel.tp_indate || '入职时间'"
            v-model="form.main.tp_indate"
            slot="tp_indate"
          />
          <date-field
            :label="customLabel.tp_outdate || '离职时间'"
            v-model="form.main.tp_outdate"
            slot="tp_outdate"
          />
          <employee-base-field
            slot="tp_handover"
            :label="customLabel.tp_handover || '交接人'"
            v-model="form.main.tp_handover"
            @select="onSelectHandover"
          />
          <div class="weui-cell" slot="tp_reason">
            <div class="weui-cell__bd">
              <textarea
                class="weui-textarea"
                :placeholder="customLabel.tp_reason || '离职原因'"
                rows="3"
                v-model="form.main.tp_reason"
                maxlength="100"
              ></textarea>
              <div class="weui-textarea-counter">
                <span>{{
                  form.main.tp_reason ? form.main.tp_reason.length : 0
                }}</span
                >/100
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="form.main.tp_type == '转正'">
          <date-field slot="tp_indate"  :label="customLabel.tp_indate || '入职时间'"  v-model="form.main.tp_indate" />
          <date-field  slot="tp_outdate" :label="customLabel.tp_outdate || '转正时间'" v-model="form.main.tp_outdate" />
          <div class="weui-cell" slot="tp_reason">
            <div class="weui-cell__bd">
              <textarea
                class="weui-textarea"
                :placeholder="customLabel.tp_reason || '试用期评价'"
                rows="3"
                v-model="form.main.tp_reason"
                maxlength="100"
              ></textarea>
              <div class="weui-textarea-counter">
                <span>{{
                  form.main.tp_reason ? form.main.tp_reason.length : 0
                }}</span
                >/100
              </div>
            </div>
          </div>
        </template>
        <template v-if="form.main.tp_type == '辞退'">
          <date-field
            :label="customLabel.tp_indate || '入职时间'"
            v-model="form.main.tp_indate"
            slot="tp_indate"
          />
          <date-field
            :label="customLabel.tp_outdate || '辞退时间'"
            v-model="form.main.tp_outdate"
            slot="tp_outdate"
          />
          <employee-field
            slot="tp_handover"
            :label="customLabel.tp_handover || '交接人'"
            v-model="form.main.tp_handover"
            @select="onSelectHandover"
          />
          <div class="weui-cell" slot="tp_amount">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.tp_amount || "补偿金额"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="form.main.tp_amount"
                placeholder="请输入"
              />
            </div>
          </div>
          <div class="weui-cell" slot="tp_reason">
            <div class="weui-cell__bd">
              <textarea
                class="weui-textarea"
                :placeholder="customLabel.tp_reason || '辞退原因'"
                rows="3"
                v-model="form.main.tp_reason"
                maxlength="100"
              ></textarea>
              <div class="weui-textarea-counter">
                <span>{{
                  form.main.tp_reason ? form.main.tp_reason.length : 0
                }}</span
                >/100
              </div>
            </div>
          </div>
        </template>
        <template v-if="form.main.tp_type == '调动'">
          <date-field
            :label="customLabel.tp_indate || '入职时间'"
            v-model="form.main.tp_indate"
            slot="tp_indate"
          />
          <date-field
            :label="customLabel.tp_outdate || '调动时间'"
            v-model="form.main.tp_outdate"
            slot="tp_outdate"
          />
          <employee-field
            slot="tp_handover"
            :label="customLabel.tp_handover || '交接人'"
            v-model="form.main.tp_handover"
            @select="onSelectHandover"
          />
          <department-field
            slot="tp_newdepartment"
            :label="customLabel.tp_newdepartment || '调动后部门'"
            v-model="form.main.tp_newdepartment"
            @select="onSelectNewDepartment"
          />
          <role-field
            slot="roles"
            :label="'调动后岗位'"
            v-model="form.main.roles"
            @select="onSelectRole"
          />
          <div class="weui-cell" slot="tp_reason">
            <div class="weui-cell__bd">
              <textarea
                class="weui-textarea"
                :placeholder="customLabel.tp_reason || '调动原因'"
                rows="3"
                v-model="form.main.tp_reason"
                maxlength="100"
              ></textarea>
              <div class="weui-textarea-counter">
                <span>{{
                  form.main.tp_reason ? form.main.tp_reason.length : 0
                }}</span
                >/100
              </div>
            </div>
          </div>
        </template>

        <file-field v-model="form.main.tp_attach" slot="tp_attach"/>
      </custom-layout>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import EmployeeBaseField from "@/components/field/EmployeeBaseField.vue";
import DateField from "@/components/field/DateField.vue";
import DepartmentField from "@/components/field/DepartmentField.vue";
import RoleField from "@/components/field/RoleField.vue";
import FileField from "@/components/field/FileField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    EmployeeBaseField,
    DateField,
    DepartmentField,
    RoleField,
    FileField,
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/oa/turnposition",
      codeField: "tp_code",
      statusField: "tp_statuscode",
      caller: "TurnPosition",
      xtype: "oa-turnposition-formpanel",
      form: {
        main: {
          tp_type: "转正",
          tp_position: null,
          tp_indate: null,
          tp_outdate: this.dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss"),
          tp_reason: null,
        },
      },
    };
  },
  mounted() {
    this.initEm()
  },
  methods: {
    initEm() {
      const me = this,
        main = me.form.main

      me.$loading({
        url: "/api/document/employee/read/current"
      }).then(function (res) {
        if (res.success) {
          const em = res.data.main

          main.tp_emname = em.em_name
          main.tp_department = em.departmentDTO.dp_name;
          main.tp_emid = em.em_id;
          main.tp_emcode = em.em_code;
          main.tp_position = em.roleNames;
        }
      })
    },
    save() {
      var me = this,
        main = me.form.main,
        checked;
      if(!main.tp_emname) {
        me.$weui.topTips("请选择人员", 2000);
        return
      }
      if (main.tp_type == "转正") {
        if (!main.tp_indate) {
          me.$weui.topTips("请选择入职时间", 2000);
        } else if (!main.tp_outdate) {
          me.$weui.topTips("请选择转正时间", 2000);
        } else if (!main.tp_reason) {
          me.$weui.topTips("请填写试用期评价", 2000);
        } else {
          checked = true;
        }
      } else if (main.tp_type == "离职") {
        if (!main.tp_indate) {
          me.$weui.topTips("请选择入职时间", 2000);
        } else if (!main.tp_outdate) {
          me.$weui.topTips("请选择离职时间", 2000);
        } else if (!main.tp_handover) {
          me.$weui.topTips("请选择交接人", 2000);
        } else if (!main.tp_reason) {
          me.$weui.topTips("请填写离职原因", 2000);
        } else {
          checked = true;
        }
      } else if (main.tp_type == "辞退") {
        if (!main.tp_indate) {
          me.$weui.topTips("请选择入职时间", 2000);
        } else if (!main.tp_outdate) {
          me.$weui.topTips("请选择辞退时间", 2000);
        } else if (!main.tp_handover) {
          me.$weui.topTips("请选择交接人", 2000);
        } else if (!main.tp_reason) {
          me.$weui.topTips("请填写辞退原因", 2000);
        } else {
          checked = true;
        }
      } else if (main.tp_type == "调动") {
        if (!main.tp_indate) {
          me.$weui.topTips("请选择入职时间", 2000);
        } else if (!main.tp_outdate) {
          me.$weui.topTips("请选择调动时间", 2000);
        } else if (!main.tp_handover) {
          me.$weui.topTips("请选择交接人", 2000);
        } else if (!main.tp_newdepartment) {
          me.$weui.topTips("请选择调动后部门", 2000);
        } else if (!main.tp_newpositionid) {
          me.$weui.topTips("请选择调动后岗位", 2000);
        } else if (!main.tp_reason) {
          me.$weui.topTips("请填写调动原因", 2000);
        } else {
          checked = true;
        }
      }
      if (checked) {
        me.p_save();
      }
    },
    onSelectEmployee(e) {
      var main = this.form.main;

      main.tp_department = e.departmentDTO.dp_name;
      main.tp_emid = e.em_id;
      main.tp_emcode = e.em_code;
      main.tp_position = e.roleNames;
    },
    onSelectHandover(e) {
      var main = this.form.main;

      main.tp_handoverid = e.em_id;
    },
    /**
     * 选择调动后部门
     */
    onSelectNewDepartment(selection) {
      var main = this.form.main;

      main.tp_newdepartmentid = selection.id
    },
    onSelectRole(selected) {
      var me = this,
        main = me.form.main;
      main.roleIds = selected.map((item) => item.id).join(",");
      main.tp_newpositionid = selected.map((item) => item.id).join(",");
    },
  },
};
</script>